<!--
  Sub-modale "Lista prodotti per collo" — nested dentro confirm-boxes
  (v2.11.0 J.4.a). Z-index 2200 (sopra cb-modal 2100).

  2 sezioni:
   - Disponibili (productsWithoutBox): prodotti senza box assegnato →
     bottone "Aggiungi a questo collo" che chiama selectProducts(prod).
   - Assegnati (productsWithBox): prodotti già nel collo →
     bottone "Rimuovi" che chiama selectMatchingProducts(prod).
-->
@if (openedProductsListBoxes) {
  <div class="lp-backdrop" (click)="close()">
    <div
      class="lp-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lp-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="lp-header">
        <div class="lp-title-block">
          <h2 id="lp-title">📦 Prodotti del collo</h2>
          @if (selectedBoxToAddProducts?.ts_box_type_desc) {
            <p class="lp-subtitle">
              Collo <strong>{{ selectedBoxToAddProducts.ts_box_type_desc }}</strong>
              · #{{ selectedBoxToAddProducts.box_order_id }}
            </p>
          } @else if (selectedBoxToAddProducts) {
            <p class="lp-subtitle">
              Collo <strong>Custom</strong> · #{{ selectedBoxToAddProducts.box_order_id }}
            </p>
          }
        </div>
        <button
          type="button"
          class="lp-close"
          aria-label="Chiudi"
          (click)="close()"
        >
          <i class="bx bx-x"></i>
        </button>
      </header>

      <!-- Body -->
      <div class="lp-body">
        @if (loading) {
          <div class="lp-loading">
            <i class="bx bx-loader-alt bx-spin"></i>
            Caricamento prodotti...
          </div>
        } @else {
          <div class="lp-columns">
            <!-- ========== Colonna SX: Disponibili ========== -->
            <section class="lp-column">
              <header class="lp-col-header lp-col-header--available">
                <h3>📥 Disponibili</h3>
                <span class="lp-count">{{ productsWithoutBox.length }}</span>
              </header>

              @if (productsWithoutBox.length === 0) {
                <div class="lp-empty">
                  <p>Nessun prodotto disponibile.</p>
                </div>
              } @else {
                <div class="lp-products-list">
                  @for (prod of productsWithoutBox; track prod.product_id; let i = $index) {
                    <!-- Con sub-products → accordion -->
                    @if (prod.sub_products?.length > 0) {
                      <details
                        class="lp-product"
                        [open]="activeAccordion === 'avail-' + i"
                        (toggle)="handleToggle($event, 'avail-' + i)"
                      >
                        <summary class="lp-product-row">
                          <div class="lp-product-info">
                            <span class="lp-product-desc">{{ prod.op_description }}</span>
                            <span class="lp-product-code">{{ prod.op_code }}</span>
                          </div>
                          <div class="lp-product-actions" (click)="$event.stopPropagation()">
                            <span class="lp-qty-badge">
                              <strong>{{ prod.minQuantity }}</strong> da assegnare
                            </span>
                            <button
                              type="button"
                              class="lp-btn lp-btn--assign"
                              title="Aggiungi a questo collo"
                              (click)="selectProducts(prod)"
                            >
                              <i class="bx bx-package"></i>
                              Aggiungi
                            </button>
                          </div>
                        </summary>
                        <div class="lp-subproducts">
                          @for (sub of prod.sub_products; track $index; let j = $index) {
                            <div class="lp-subproduct">
                              <div class="lp-sub-info">
                                <span class="lp-sub-desc">{{ sub.osp_description }}</span>
                                <span class="lp-sub-code">{{ sub.osp_code }}</span>
                              </div>
                              <span class="lp-sub-qty">
                                <strong>{{ sub.barcodes.length }}</strong> / {{ sub.osp_qty_ordered }} pz
                              </span>
                            </div>
                          }
                        </div>
                      </details>
                    }

                    <!-- Senza sub-products → row plain -->
                    @if (!prod.sub_products?.length) {
                      <div class="lp-product lp-product--plain">
                        <div class="lp-product-info">
                          <span class="lp-product-desc">{{ prod.op_description }}</span>
                          <span class="lp-product-code">{{ prod.op_code }}</span>
                        </div>
                        <div class="lp-product-actions">
                          <span class="lp-qty-badge">
                            <strong>{{ prod.minQuantity }}</strong> da assegnare
                          </span>
                          <button
                            type="button"
                            class="lp-btn lp-btn--assign"
                            title="Aggiungi a questo collo"
                            (click)="selectProducts(prod)"
                          >
                            <i class="bx bx-package"></i>
                            Aggiungi
                          </button>
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </section>

            <!-- ========== Colonna DX: Assegnati ========== -->
            <section class="lp-column">
              <header class="lp-col-header lp-col-header--assigned">
                <h3>📦 Nel collo</h3>
                <span class="lp-count">{{ productsWithBox.length }}</span>
              </header>

              @if (productsWithBox.length === 0) {
                <div class="lp-empty">
                  <p>Nessun prodotto assegnato.</p>
                </div>
              } @else {
                <div class="lp-products-list">
                  @for (prod of productsWithBox; track prod.product_id; let i = $index) {
                    <!-- Con sub-products → accordion -->
                    @if (prod.sub_products?.length > 0) {
                      <details
                        class="lp-product lp-product--assigned"
                        [open]="activeAccordion === 'assig-' + i"
                        (toggle)="handleToggle($event, 'assign-' + i)"                      
                      >
                        <summary class="lp-product-row">
                          <div class="lp-product-info">
                            <span class="lp-product-desc">{{ prod.op_description }}</span>
                            <span class="lp-product-code">{{ prod.op_code }}</span>
                          </div>
                          <div class="lp-product-actions" (click)="$event.stopPropagation()">
                            <span class="lp-qty-badge lp-qty-badge--assigned">
                              <strong>{{ prod.minQuantity }}</strong> assegnati
                            </span>
                            <button
                              type="button"
                              class="lp-btn lp-btn--remove"
                              title="Rimuovi dal collo"
                              (click)="selectMatchingProducts(prod)"
                            >
                              <i class="bx bx-undo"></i>
                              Rimuovi
                            </button>
                          </div>
                        </summary>
                        <div class="lp-subproducts">
                          @for (sub of prod.sub_products; track $index; let j = $index) {
                            <div class="lp-subproduct lp-subproduct--assigned">
                              <div class="lp-sub-info">
                                <span class="lp-sub-desc">{{ sub.osp_description }}</span>
                                <span class="lp-sub-code">{{ sub.osp_code }}</span>
                              </div>
                              <span class="lp-sub-qty">
                                <strong>{{ sub.barcodes.length }}</strong> pz
                              </span>
                            </div>
                          }
                        </div>
                      </details>
                    }

                    <!-- Senza sub-products → row plain -->
                    @if (!prod.sub_products?.length) {
                      <div class="lp-product lp-product--plain lp-product--assigned">
                        <div class="lp-product-info">
                          <span class="lp-product-desc">{{ prod.op_description }}</span>
                          <span class="lp-product-code">{{ prod.op_code }}</span>
                        </div>
                        <div class="lp-product-actions">
                          <span class="lp-qty-badge lp-qty-badge--assigned">
                            <strong>{{ prod.minQuantity }}</strong> assegnati
                          </span>
                          <button
                            type="button"
                            class="lp-btn lp-btn--remove"
                            title="Rimuovi dal collo"
                            (click)="selectMatchingProducts(prod)"
                          >
                            <i class="bx bx-undo"></i>
                            Rimuovi
                          </button>
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </section>
          </div>
        }
      </div>

      <!-- Footer -->
      <footer class="lp-footer">
        <button type="button" class="lp-btn lp-btn--close" (click)="close()">
          <i class="bx bx-check-circle"></i>
          Fatto
        </button>
      </footer>
    </div>
  </div>
}
